import GlobalStyle from "./styles/globalStyles";
import { ThemeProvider } from "styled-components";

import theme from "./styles/themes";
import RouteConfig from "./routes";

import "./styles/App.css";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "./redux/reduxTypes";
import { useCallback, useEffect, useState } from "react";
import { ConfigsSet, getSession } from "./utils/session-helper";
import { GcoopSessionConfig, LoginState } from "./types/state.types";
import sessionConfigsActions from "./redux/config-sessao/actions";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import loginActions from "./redux/login/actions";

function App() {
  const dispatch = useDispatch();
  const configsState = useSelector<StoreState, GcoopSessionConfig>(
    (state) => state.configsState
  );
  const loginState: LoginState = useSelector<StoreState, LoginState>(
    (state) => state.loginState
  );
  const [localTheme, setTheme] = useState(theme("#0008"));
  const [lastClick, setLastClick] = useState<number | null>(null);
  const [clicked, setClicked] = useState<{
    status: boolean;
    lastClick: number;
  }>({ status: false, lastClick: 0 });

  useEffect(() => {
    if (configsState.Configuracoes) {
      setTheme(
        theme(
          configsState.Configuracoes.find((item) => item.ID === ConfigsSet.Cor)
            ?.Valor ?? "#006599"
        )
      );
    }
  }, [configsState.Configuracoes]);

  useEffect(() => {
    window.addEventListener("beforeunload", async (event) => {
      localStorage.setItem("gcoop-last-unload", `${Date.now()}`);
    });
    document.addEventListener("click", () => {
      setClicked({ status: true, lastClick: Date.now() });
    });

    const lastUnload = localStorage.getItem("gcoop-last-unload");
    if (lastUnload && Date.now() - Number(lastUnload) > 600) {
      localStorage.removeItem("gcoop-last-unload");

      dispatch(loginActions.logout());
    }

    dispatch(loginActions.iniciarEstadoLogin());
    dispatch(sessionConfigsActions.getSessionConfigs());

    if (loginState.logged && loginState.userData) {
      dispatch(
        sessionConfigsActions.updateSessionData(loginState.userData.CPF)
      );
    }
  }, [dispatch]);

  const updateSession = useCallback(async () => {
    const session = await getSession();
    dispatch(loginActions.setTempSession(session.userData));
    dispatch(loginActions.setSession());
  }, [dispatch]);

  useEffect(() => {
    if (
      loginState.logged &&
      (!lastClick ||
        (clicked.lastClick && clicked.lastClick - lastClick > 15000))
    ) {
      setLastClick(clicked.lastClick);
      updateSession();
    }
  }, [loginState.logged, clicked, setLastClick, lastClick, updateSession]);

  return (
    <ThemeProvider theme={localTheme}>
      <GlobalStyle />

      {configsState.loading ? (
        <Spin
          fullscreen
          indicator={<LoadingOutlined style={{ fontSize: 50 }} spin />}
          size="large"
        />
      ) : (
        <RouteConfig
          logged={loginState.logged}
          routePermissions={configsState}
        />
      )}
    </ThemeProvider>
  );
}

export default App;
